import React from "react";
import Button from "./Button";

interface Props {
  // Importe total a pagar. Si es <= 0 la barra no se muestra.
  importe: number;
  // Acción al tocar el botón de pago.
  onPagar: () => void;
  // Acción opcional para deseleccionar todos los talones de una.
  onCancelar?: () => void;
  // Texto del botón de pago (por defecto "Pago Online").
  label?: string;
  // Muestra el spinner de "Cargando..." en el botón de pago.
  loading?: boolean;
}

/**
 * Barra flotante fija al pie de la pantalla (web y mobile) con el importe y el
 * botón de pago. Aparece automáticamente al seleccionar talones, para que el
 * usuario no tenga que scrollear hasta el final de tablas largas para pagar.
 * Es sticky dentro del contenedor del contenido: queda de su ancho y no se
 * superpone con el sidebar.
 */
export default function BarraPagoFlotante({
  importe,
  onPagar,
  onCancelar,
  label = "Pago Online",
  loading = false,
}: Props) {
  if (!(importe > 0)) return null;

  const monto = new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(importe);

  return (
    <div className="pago-flotante" role="region" aria-label="Barra de pago">
      <div className="pago-flotante-inner">
          <div className="pago-flotante-importe">
            <span className="pago-flotante-label">Importe neto a pagar</span>
            <span className="pago-flotante-monto">${monto}</span>
          </div>
          <div className="pago-flotante-actions">
            {onCancelar && (
              <Button title="Cancelar" secondary onPress={onCancelar} />
            )}
            <Button title={label} onPress={onPagar} onLoad={loading} />
          </div>
      </div>
    </div>
  );
}
